/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

$(function() {
  var $searchlink = $('#searchlink');

  // hover effect
  /*$searchlink.on('mouseover', function(){
     $(this).addClass('open');
   }).on('mouseout', function(){
     $(this).removeClass('open');
   });*/

  //on click effect
  $searchlink.on('click', function(e){
    var target = e ? e.target : window.event.srcElement;

    if($(target).attr('id') == 'searchlink') {
      if($(this).hasClass('open')) {
        $(this).removeClass('open');
      } else {
        $(this).addClass('open');
      }
    }
  });
});

$(document).ready(function() {
  //   {"max-height": "100px;","overflow": "hidden;"}
  $('.ProductMeta__Description').addClass('read_small');
  $('<a class="read_more" href="javascript:void(0);">Read More >></a>').insertAfter('.ProductMeta__Description');

  $(document).on('click', '.read_more', function(){
    $('.ProductMeta__Description').toggleClass('read_small');
    $(this).hide();
  });

  $(".zoom").elevateZoom({constrainType:"height", constrainSize:500, zoomType: "lens", lensSize:250, containLensZoom: true, cursor: 'pointer', galleryActiveClass: "active"});

});
